import clearForm from "../utils/clearForm";

export default function clearFormWidget(element) {
    element.addEventListener("click", function (event) {
        event.stopPropagation();
        const form = element.closest("form");
        if (form) clearForm(form);
    });
}
